import { Box, Flex, Text } from "@storyofams/react-ui";
import Image from "next/image";

export const Ingredients = ({ content, close }) => {
  const scrollToIngredientsSection = () => {
    const el = document?.getElementById("ingredients-cards");

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      {content?.map((item, i) => (
        <Flex mt={i && 2} key={item.title}>
          <Box
            mr={2}
            position={"relative"}
            width={86}
            height={61}
            maxWidth={86}
            flexGrow={0}
            flexShrink={0}
          >
            <Image
              objectFit="cover"
              layout="fill"
              src={item.image.filename}
            ></Image>
          </Box>
          <Box>
            <Text fontWeight={500} fontSize={2} lineHeight={"22.4px"}>
              {item.title}
            </Text>
            <Text
              mt="6px"
              color={"#1D1D1BCC"}
              fontSize={"14px"}
              lineHeight={"19.6px"}
            >
              {item.description}
            </Text>
          </Box>
        </Flex>
      ))}
      <Text
        mt={2}
        fontWeight={500}
        fontSize={2}
        color="#1D1D1BCC"
        textAlign={"end"}
        cursor={"pointer"}
        onClick={() => {
          close();
          setTimeout(() => scrollToIngredientsSection(), 500);
        }}
      >
        View all ingredients
      </Text>
    </Box>
  );
};
